export default "__VITE_ASSET__jT9ctQU36D9OFz_M9$qOkQ__"